"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _CreativeLayer2 = _interopRequireDefault(require("./CreativeLayer"));

var _convertMapToObject = _interopRequireDefault(require("../../utils/object/convertMapToObject"));

var _convertObjectToMap = _interopRequireDefault(require("../../utils/object/convertObjectToMap"));

var _convertPixelToEm = _interopRequireDefault(require("../../utils/font/convertPixelToEm"));

var _getTextAlign = _interopRequireDefault(require("../../utils/text/getTextAlign"));

var _isArray = _interopRequireDefault(require("../../utils/object/isArray"));

var _isEmpty = _interopRequireDefault(require("../../utils/object/isEmpty"));

var _isNotEmptyString = _interopRequireDefault(require("../../utils/object/isNotEmptyString"));

var _isNotNil = _interopRequireDefault(require("../../utils/object/isNotNil"));

var _isNumber = _interopRequireDefault(require("../../utils/numbers/isNumber"));

var _creative = require("../../constants/creative");

var _text = require("../../constants/text");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var TextCreativeLayer = /*#__PURE__*/function (_CreativeLayer) {
  (0, _inherits2["default"])(TextCreativeLayer, _CreativeLayer);

  var _super = _createSuper(TextCreativeLayer);

  /**
   * font color
   */

  /**
   * fill properties
   */

  /**
   * font adjustment
   */

  /**
   * font data to load selected font
   */

  /**
   * font name
   */

  /**
   * font size
   */

  /**
   * horizontal text alignment
   */

  /**
   * letter spacing
   */

  /**
   * line spacing
   */

  /**
   * Number in pixels of the natural rendered height of the content (text)
   */

  /**
   * Number in pixels of the natural rendered width of the content (text)
   */

  /**
   * overflow x
   */

  /**
   * overflow y
   */

  /**
   * padding
   */

  /**
   * rendered font size
   */

  /**
   * stroke color
   */

  /**
   * stroke width
   */

  /**
   * text effect
   */

  /**
   * text lines of Text Creative Layer
   */

  /**
   * text string of Text Creative Layer
   */

  /**
   * text type either SVG, or CANVAS
   * @type {string}
   * @private
   */

  /**
   * vertical text alignment
   */

  /**
   * text wrap properties
   *
   * TODO(lemieux) consider changing this from a Map to something else or using TypeScript here
   */
  function TextCreativeLayer(element, content, media) {
    var _this;

    (0, _classCallCheck2["default"])(this, TextCreativeLayer);
    _this = _super.call(this, element, content, media);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fillColor", _creative.DEFAULT_FILL_COLOR);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fillProperties", new Map());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fontAdjustment", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fontData", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fontName", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fontSize", "".concat(_text.DEFAULT_FONT_SIZE, "px"));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_horizontalAlignment", _text.TEXT_ALIGNMENT.LEFT);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_letterSpacing", _text.DEFAULT_LETTER_SPACING);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_lineSpacing", _text.DEFAULT_LINE_SPACING);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_naturalHeight", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_naturalWidth", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_overflowX", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_overflowY", _text.OVERFLOW_Y.HIDDEN);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_padding", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedFontSize", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_strokeColor", _text.DEFAULT_STROKE_COLOR);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_strokeWidth", _text.DEFAULT_STROKE_WIDTH);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textEffect", new Map());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textLines", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textString", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textType", _text.DEFAULT_TEXT_TYPE);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_verticalAlignment", _text.DEFAULT_VERTICAL_TEXT_ALIGNMENT);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_wrapProperties", new Map());
    var horizontalAlignment = content.alignment,
        fillColor = content.fillColor,
        fontSize = content.fontSize,
        font = content.font,
        letterSpacing = content.letterSpacing,
        lineSpacing = content.lineSpacing,
        naturalWidth = content.naturalWidth,
        naturalHeight = content.naturalHeight,
        overflowX = content.overflowX,
        overflowY = content.overflowY,
        padding = content.padding,
        renderedFontSize = content.renderedFontSize,
        strokeColor = content.strokeColor,
        strokeWidth = content.strokeWidth,
        textEffect = content.textEffect,
        fillProperties = content.textFill,
        textLines = content.textLines,
        textString = content.textString,
        textType = content.textType,
        textWrap = content.textWrap,
        verticalAlignment = content.verticalAlignment; // set up text properties

    if ((0, _isNotEmptyString["default"])(fillColor)) {
      _this._fillColor = fillColor;
    }

    if (!(0, _isEmpty["default"])(fillProperties)) {
      _this._fillProperties = (0, _convertObjectToMap["default"])(fillProperties);
    } else {
      _this._fillProperties.set('mode', _text.DEFAULT_TEXT_FILL);
    }

    if ((0, _isNotEmptyString["default"])(font)) {
      _this._fontName = font;
    }

    if ((0, _isNotNil["default"])(fontSize)) {
      _this._fontSize = fontSize;
    }

    if ((0, _isNotNil["default"])(_text.TEXT_ALIGNMENT[horizontalAlignment])) {
      _this._horizontalAlignment = horizontalAlignment;
    }

    if ((0, _isNumber["default"])(letterSpacing)) {
      _this._letterSpacing = letterSpacing;
    }

    if ((0, _isNumber["default"])(lineSpacing)) {
      _this._lineSpacing = lineSpacing;
    }

    if ((0, _isNumber["default"])(naturalHeight)) {
      _this._naturalHeight = naturalHeight;
    }

    if ((0, _isNumber["default"])(naturalWidth)) {
      _this._naturalWidth = naturalWidth;
    }

    if (_text.VALID_OVERFLOW_X.has(overflowX)) {
      _this._overflowX = overflowX;
    }

    if (_text.VALID_OVERFLOW_Y.has(overflowY)) {
      _this._overflowY = overflowY;
    }

    if ((0, _isNumber["default"])(padding)) {
      _this._padding = padding;
    }

    if (!(0, _isEmpty["default"])(textEffect)) {
      _this._textEffect = (0, _convertObjectToMap["default"])(textEffect);
    }

    if ((0, _isArray["default"])(textLines)) {
      _this._textLines = textLines;
    }

    if ((0, _isNotEmptyString["default"])(textString)) {
      _this._textString = textString;
    }

    if (_text.VALID_TEXT_TYPES.has(textType)) {
      _this._textType = textType;
    }

    if (_text.VALID_VERTICAL_TEXT_ALIGNMENT.has(verticalAlignment)) {
      _this._verticalAlignment = verticalAlignment;
    }

    if (!(0, _isEmpty["default"])(textWrap)) {
      _this._wrapProperties = (0, _convertObjectToMap["default"])(textWrap);
    }

    if ((0, _isNotEmptyString["default"])(strokeColor)) {
      _this._strokeColor = strokeColor;
    }

    if ((0, _isNumber["default"])(strokeWidth)) {
      _this._strokeWidth = strokeWidth;
    }

    if ((0, _isNotNil["default"])(renderedFontSize)) {
      _this._renderedFontSize = renderedFontSize;
    } else {
      _this._renderedFontSize = fontSize;
    }

    var height = media.height,
        fontAdjustment = media.fontAdjustment,
        width = media.width;

    if ((0, _isNumber["default"])(height)) {
      _this._height = height;
    }

    if ((0, _isNumber["default"])(fontAdjustment)) {
      _this._fontAdjustment = fontAdjustment;
    }

    if ((0, _isNumber["default"])(width)) {
      _this._width = width;
    }

    return _this;
  }

  (0, _createClass2["default"])(TextCreativeLayer, [{
    key: "internalGenerateContentStoreId",
    value: function internalGenerateContentStoreId() {
      return "".concat(this._contentId, "-").concat(this._textType);
    }
  }, {
    key: "fontAdjustment",
    get: function get() {
      return this._fontAdjustment;
    }
  }, {
    key: "fillColor",
    get: function get() {
      return this._fillColor;
    }
  }, {
    key: "fillProperties",
    get: function get() {
      return this._fillProperties;
    }
  }, {
    key: "fontData",
    get: function get() {
      return this._fontData;
    },
    set: function set(value) {
      this._fontData = value;
    }
  }, {
    key: "overflowY",
    set: function set(value) {
      this._overflowY = value;
    },
    get: function get() {
      return this._overflowY;
    }
  }, {
    key: "fontName",
    get: function get() {
      return this._fontName;
    },
    set: function set(fontName) {
      this._fontName = fontName;
    }
  }, {
    key: "fontSize",
    get: function get() {
      return this._fontSize;
    }
  }, {
    key: "horizontalAlignment",
    get: function get() {
      return this._horizontalAlignment;
    }
  }, {
    key: "letterSpacing",
    get: function get() {
      return this._letterSpacing;
    }
  }, {
    key: "lineSpacing",
    get: function get() {
      return this._lineSpacing;
    }
  }, {
    key: "naturalHeight",
    get: function get() {
      return this._naturalHeight;
    }
  }, {
    key: "naturalWidth",
    get: function get() {
      return this._naturalWidth;
    }
  }, {
    key: "overflowX",
    get: function get() {
      return this._overflowX;
    }
  }, {
    key: "padding",
    get: function get() {
      return this._padding;
    }
  }, {
    key: "renderedFontSize",
    get: function get() {
      return this._renderedFontSize;
    }
  }, {
    key: "properties",
    get: function get() {
      var horizontalAlignment = this.horizontalAlignment,
          fillColor = this.fillColor,
          fillProperties = this.fillProperties,
          fontName = this.fontName,
          fontSize = this.fontSize,
          letterSpacing = this.letterSpacing,
          lineSpacing = this.lineSpacing,
          naturalHeight = this.naturalHeight,
          naturalWidth = this.naturalWidth,
          overflowX = this.overflowX,
          overflowY = this.overflowY,
          padding = this.padding,
          renderedFontSize = this.renderedFontSize,
          textLines = this.textLines,
          textString = this.textString,
          textType = this.textType,
          verticalAlignment = this.verticalAlignment;
      return {
        fillColor: fillColor,
        fontSize: fontSize,
        letterSpacing: letterSpacing,
        lineSpacing: lineSpacing,
        naturalHeight: naturalHeight,
        naturalWidth: naturalWidth,
        overflowX: overflowX,
        overflowY: overflowY,
        padding: padding,
        renderedFontSize: renderedFontSize,
        textLines: textLines,
        textString: textString,
        textType: textType,
        verticalAlignment: verticalAlignment,
        alignment: horizontalAlignment,
        font: fontName,
        textAlign: (0, _getTextAlign["default"])(horizontalAlignment),
        textFillProperties: (0, _convertMapToObject["default"])(fillProperties)
      };
    }
  }, {
    key: "strokeColor",
    get: function get() {
      return this._strokeColor;
    },
    set: function set(value) {
      this._strokeColor = value;
    }
  }, {
    key: "strokeWidth",
    get: function get() {
      return this._strokeWidth;
    },
    set: function set(value) {
      this._strokeWidth = value;
    }
  }, {
    key: "styles",
    get: function get() {
      var fill = this.fillColor,
          fontFamily = this.fontName,
          fontSize = this.fontSize,
          padding = this.padding,
          verticalAlign = this.verticalAlign,
          letterSpacing = this.letterSpacing,
          lineSpacing = this.lineSpacing;
      return {
        fill: fill,
        fontFamily: fontFamily,
        fontSize: fontSize,
        padding: padding,
        verticalAlign: verticalAlign,
        letterSpacing: "".concat((0, _convertPixelToEm["default"])(letterSpacing), "em"),
        lineHeight: "".concat(lineSpacing, "em")
      };
    }
  }, {
    key: "textEffect",
    get: function get() {
      return this._textEffect;
    }
  }, {
    key: "textLines",
    get: function get() {
      return this._textLines;
    }
  }, {
    key: "textString",
    get: function get() {
      return this._textString;
    }
  }, {
    key: "textType",
    get: function get() {
      return this._textType;
    },
    set: function set(value) {
      this._textType = value;
    }
  }, {
    key: "verticalAlignment",
    get: function get() {
      return this._verticalAlignment;
    }
  }, {
    key: "wrapProperties",
    get: function get() {
      return this._wrapProperties;
    }
    /**
     * Checks if object is an instance of TextCreativeLayer
     *
     * @param inputObject
     * @returns {boolean}
     */

  }], [{
    key: "isTextCreativeLayer",
    value: function isTextCreativeLayer(inputObject) {
      return inputObject instanceof TextCreativeLayer;
    }
  }]);
  return TextCreativeLayer;
}(_CreativeLayer2["default"]);

exports["default"] = TextCreativeLayer;